import './_AboutCompany.scss'
import Header from "../../header/Header";
import Footer from "../../footer/Footer";
import max from '../../../assets/images/max_new.png'
import lawrence from '../../../assets/images/lou.png'
import {useEffect, useState} from "react";
import MmailchimpSubscribe from "../../popup/MmailchimpSubscribe";
import Popup from "../../popup/Popup";


const AboutCompany = () => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const openPopup = () => {
        setIsPopupOpen(true);
        document.body.classList.add('disable-scroll');
    };

    const closePopup = () => {
        setIsPopupOpen(false);
        document.body.classList.remove('disable-scroll');
    };

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (<>
            <Header openPopup={(v) => openPopup(v)}/>
            <div className='about-company-box'>
                <div className='container'>
                    <div className='crumbs'>
                        <p><a href="/">Home</a> / <span>About us</span></p>
                    </div>
                    <div className='container-content'>
                        <div className='left-box'>
                            <div>
                                <img src={lawrence} alt=""/>
                                <div className='box-text'>
                                    <h4>co-founder</h4>
                                    <p>Lawrence Scheibner</p>
                                </div>
                            </div>
                            <div className='max-img'>
                                <img src={max} alt=""/>
                                <div className='box-text'>
                                    <h4>co-founder</h4>
                                    <p>Maxim Goncharov</p>
                                </div>
                            </div>
                        </div>
                        <div className='right-box'>
                            <h2>Our story</h2>
                            <p>The idea for PivotHawk was born in Gem, Canada, where my farmer friend Lawrence and I
                                were struggling to control irrigation systems in large, remote fields. The limited time
                                and long distances made it impossible to quickly identify faults, resulting in water and
                                crop losses and operational inefficiencies.</p>
                            <div className='left-box mob'>
                                <div>
                                    <img src={lawrence} alt=""/>
                                    <div className='box-text'>
                                        <h4>co-founder</h4>
                                        <p>Lawrence Scheibner</p>
                                    </div>
                                </div>
                                <div className='max-img'>
                                    <img src={max} alt=""/>
                                    <div className='box-text'>
                                        <h4>co-founder</h4>
                                        <p>Maxim Goncharov</p>
                                    </div>
                                </div>
                            </div>
                            <h2 className='last'>Vision</h2>
                            <p>PivotHawk isn’t just a local solution — it’s a global revolution in smart irrigation.
                                With over 200,000+ center pivots in North America and 1M+ worldwide, farmers everywhere
                                face the same problem. Our goal is to equip every pivot system on the planet with
                                real-time, affordable, and efficient monitoring — saving millions of hours, gallons of
                                fuel, and thousands of dollars for unused water due to downtime.</p>
                        </div>
                    </div>
                </div>

            </div>
            <Footer/>
            <Popup isOpen={isPopupOpen} onClose={closePopup}>
                <MmailchimpSubscribe closeForm={closePopup}/>
            </Popup>
        </>
    );
};

export default AboutCompany
